// apps/api/src/qxcircle/qxcircle-comment-update.ts
// Description: QXCircle edit own comment body — Slice 26.
// Owner: Masa Bayu
// Date: 2026-08-24

import {
  BadRequestException,
  ForbiddenException,
  NotFoundException,
} from "./_nestjs-common";
import { isManagedQxCircleComment, presentQxCircleComment } from "./qxcircle-comment-delete";
import type { QxCircleComment } from "./qxcircle.types";
import { QXCIRCLE_COMMENT_BODY_MAX } from "./qxcircle.types";

export function updateQxCircleCommentRecord(
  postId: string,
  commentId: string,
  bodyRaw: string,
  comments: QxCircleComment[],
  accountId: string,
): QxCircleComment {
  const body = bodyRaw.trim();
  if (!body) {
    throw new BadRequestException("Comment body is required");
  }
  if (body.length > QXCIRCLE_COMMENT_BODY_MAX) {
    throw new BadRequestException(
      `Comment body max ${QXCIRCLE_COMMENT_BODY_MAX} characters`,
    );
  }
  const comment = comments.find(
    (c) => c.id === commentId && c.postId === postId,
  );
  if (!comment) {
    throw new NotFoundException(`Comment not found: ${commentId}`);
  }
  if (!isManagedQxCircleComment(comment, accountId)) {
    throw new ForbiddenException("Only your comments can be edited");
  }
  comment.body = body;
  comment.updatedAt = new Date().toISOString();
  return presentQxCircleComment(comment, accountId);
}
